export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/activity-logs/get/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/activity-logs',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/activity-logs',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'put',
      url: `/activity-logs/${id}`,
      data: payload,
    });
  },
});
